/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_WebhooksInputs */

const en_directory_agent_readiness_check_webhooks = /** @type {(inputs: Directory_Agent_Readiness_Check_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhooks`)
};

const zh_directory_agent_readiness_check_webhooks = /** @type {(inputs: Directory_Agent_Readiness_Check_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhooks`)
};

/**
* | output |
* | --- |
* | "Webhooks" |
*
* @param {Directory_Agent_Readiness_Check_WebhooksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_webhooks = /** @type {((inputs?: Directory_Agent_Readiness_Check_WebhooksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_WebhooksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_webhooks(inputs)
	return zh_directory_agent_readiness_check_webhooks(inputs)
});
export { directory_agent_readiness_check_webhooks as "directory.agent_readiness.check.webhooks" }